<app-modal [open]="open" (closed)="close()">
  <div modal-header>
    @if (!booking) {
      <h2>{{ 'bookings.create-modal.title' | transloco }}</h2>
    }
    @if (booking) {
      <h2>{{ 'bookings.create-modal.edit.title' | transloco }}</h2>
    }
  </div>

  <div modal-body>
    <form [formGroup]="form" (ngSubmit)="create()">
      <div class="input-group">
        <label>{{ 'bookings.create-modal.email.label' | transloco }}</label>
        <input type="email"
          formControlName="customerEmail"
          placeholder="{{ 'bookings.create-modal.email.placeholder' | transloco }}" />
      </div>

      <div class="input-group">
        <label>{{ 'bookings.create-modal.service.label' | transloco }}</label>
        <select formControlName="serviceId">
          <option value="" disabled selected>{{ 'bookings.create-modal.service.placeholder' | transloco }}</option>
          @for (service of services; track service) {
            <option [value]="service.id">
              {{ service.name }}
            </option>
          }
        </select>
        @if (services.length === 0) {
          <div class="info info--danger">
            <div class="info__icon">
              <i class="fa-solid fa-circle-info"></i>
            </div>
            <p>{{ 'bookings.create-modal.service.help' | transloco }}</p>
          </div>
        }
      </div>

      @if (selectedService?.allowDeposit && selectedService?.depositPercentage) {
        <div class="input-group input-group--toggle">
          <label>{{ 'bookings.create-modal.deposit.toggle' | transloco : { percentage: selectedService?.depositPercentage } }}</label>
          <app-toggle [toggled]="form.value.deposit !== null" (onChange)="onDepositToggle($event)"></app-toggle>
        </div>
        <div class="info info--primary">
          <div class="info__icon">
            <i class="fa-solid fa-circle-info"></i>
          </div>
          <p>{{ 'bookings.create-modal.deposit.help' | transloco : { percentage: selectedService?.depositPercentage } }}</p>
        </div>
      }

      <div class="input-group">
        <label>{{ 'bookings.create-modal.datetime.label' | transloco }}</label>
        <input type="datetime-local"
          formControlName="datetime"
          [min]="minDateTime"
          placeholder="{{ 'bookings.create-modal.datetime.placeholder' | transloco }}" />
      </div>
    </form>
  </div>

  <div modal-footer>
    <div class="actions">
      <button type="button" class="button button--secondary" (click)="close()">
        {{ 'bookings.create-modal.cancel' | transloco }}
      </button>
      <button type="submit" class="button"
        [disabled]="form.invalid"
        (click)="create()">
        {{ 'bookings.create-modal.create' | transloco }}
      </button>
    </div>
  </div>
</app-modal>
